  document.addEventListener('DOMContentLoaded', function () {
    const collectionSlider = document.querySelector('.menu-collections-slider');
    const collectionItems = document.querySelectorAll('.menu-collection-item');
    const collectionDots = document.querySelectorAll('.menu-collections-dots span');

    function setActive(index, items, dots) {
      items.forEach((el) => el.classList.remove('active'));
      if (dots) dots.forEach((el) => el.classList.remove('active'));

      if (items[index]) items[index].classList.add('active');
      if (dots && dots[index]) dots[index].classList.add('active');
    }

    function setupAutoSlider(slider, items, dots) {
      let currentIndex = 0;
      let autoplayInterval;

      function updateActiveOnScroll() {
        let sliderCenter = slider.scrollLeft + slider.offsetWidth / 2;
        let closestIndex = 0;
        let closestDistance = Infinity;

        items.forEach((item, index) => {
          let itemCenter = item.offsetLeft + item.offsetWidth / 2;
          let distance = Math.abs(sliderCenter - itemCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        currentIndex = closestIndex;
        setActive(closestIndex, items, dots);
      }

      function startAutoplay() {
        stopAutoplay();
        autoplayInterval = setInterval(() => {
          currentIndex = (currentIndex + 1) % items.length;
          slider.scrollTo({
            left: items[currentIndex].offsetLeft - (slider.offsetWidth - items[currentIndex].offsetWidth) / 2,
            behavior: 'smooth',
          });
        }, 3000);
      }

      function stopAutoplay() {
        if (autoplayInterval) clearInterval(autoplayInterval);
      }

      slider.addEventListener('scroll', updateActiveOnScroll);
      slider.addEventListener('touchstart', stopAutoplay);
      slider.addEventListener('mousedown', stopAutoplay);

      if (dots) {
        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            stopAutoplay();
            slider.scrollTo({
              left: items[index].offsetLeft - (slider.offsetWidth - items[index].offsetWidth) / 2,
              behavior: 'smooth',
            });
          });
        });
      }

      setActive(0, items, dots);
      startAutoplay();
    }

    // Collection Slider
    if (collectionSlider && collectionItems.length > 1) {
      setupAutoSlider(collectionSlider, collectionItems, collectionDots);
    }

    // Mega Menu Image Sliders
    document.querySelectorAll('.mobile-nav__images-wrapper').forEach((wrapper) => {
      const scroller = wrapper.querySelector('.mobile-nav__images-scroller');
      const items = wrapper.querySelectorAll('.mobile-nav__image-push');
      if (scroller && items.length > 1) {
        setupAutoSlider(scroller, items);
      }
    });
  });